import React, { useEffect, useState } from "react";
import { httpGet, httpPost } from "../../components/helpers/httpMethods";
import "./bills.css";

// Pay bills reward: every 10 delivered bills = one free old issue from a day the reader chooses (kept in My library).
// Server: /api/bills/reward, /reward/editions?date=, /reward/claim. compact = the Overview card (only when one is waiting).
const errText = (r, fallback) => (r && r.er && (r.er.message || (typeof r.er === "string" ? r.er : ""))) || fallback;
const longDay = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
const yesterday = (today) => { const d = new Date(`${today}T12:00:00`); d.setDate(d.getDate() - 1); return d.toISOString().slice(0, 10); };

export function BillsReward({ history, compact }) {
  const [r, setR] = useState(null);
  const [date, setDate] = useState("");
  const [list, setList] = useState(null);
  const [busy, setBusy] = useState("");
  const [error, setError] = useState("");
  useEffect(() => { httpGet("bills/reward").then((x) => setR(x && x.data ? x.data : null)); }, []);
  useEffect(() => {
    if (r && !compact && window.location.hash === "#reward") { const el = document.getElementById("reward"); if (el) el.scrollIntoView({ behavior: "smooth", block: "start" }); }
  }, [r, compact]);

  if (!r) return null;
  if (compact) {
    if (!r.available) return null;
    return (
      <section className="ac-card ac-offer bl-reward-card">
        <span className="ac-offer-icon bl-reward-icon" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h12a4 4 0 0 1 4 4v12H8a4 4 0 0 1-4-4z" /><path d="M8 9h8M8 13h8M8 17h4" /></svg></span>
        <span className="ac-offer-text"><strong>Free old issue earned</strong><small>Thanks for paying your bills with us. Pick any day, like a birthday or a big day, and read that day’s paper free.</small></span>
        <button type="button" className="ac-btn" onClick={() => history.push("/account/bills#reward")}>Choose your day</button>
      </section>
    );
  }

  const show = async (e) => {
    e.preventDefault();
    if (!date) return;
    setError(""); setList(null); setBusy("load");
    const x = await httpGet(`bills/reward/editions?date=${date}`);
    setBusy("");
    if (x && x.data && Array.isArray(x.data.editions)) setList(x.data.editions);
    else setError(errText(x, "Papers couldn’t be loaded. Please try again."));
  };
  const claim = async (ed) => {
    setError(""); setBusy(ed.id);
    const x = await httpPost("bills/reward/claim", { editionId: ed.id });
    setBusy("");
    if (x && x.data && x.data.editionId) { history.push(`/view_single_paper/${x.data.editionId}`); return; }
    setError(errText(x, "That didn’t work. Please try again."));
  };

  if (!r.available) {
    const done = r.every - r.toNext;
    return (
      <div className="bl-progress" id="reward">
        <div className="bl-progress-top">
          <span><strong>{r.toNext} more bill{r.toNext === 1 ? "" : "s"}</strong> to a free old issue from any day you choose</span>
          <span className="ac-muted">{done} of {r.every}</span>
        </div>
        <div className="bl-progress-track" role="progressbar" aria-valuemin={0} aria-valuemax={r.every} aria-valuenow={done} aria-label="Bills towards your free old issue"><span style={{ width: `${(100 * done) / r.every}%` }} /></div>
      </div>
    );
  }

  return (
    <section className="ac-card bl-card bl-reward" id="reward" aria-labelledby="bl-reward-h">
      <div>
        <h2 id="bl-reward-h" className="bl-h2">You’ve earned a free old issue{r.available > 1 ? ` (${r.available} waiting)` : ""}</h2>
        <p className="ac-muted bl-reward-sub">Pick a day that means something to you: a birthday, a wedding, a graduation. We’ll show every paper we have from that day.</p>
      </div>
      <form className="bl-row" onSubmit={show}>
        <label className="bl-field">The day
          <input type="date" value={date} min={r.firstDate || undefined} max={yesterday(r.today)} onChange={(e) => { setDate(e.target.value); setList(null); }} required />
        </label>
        <button type="submit" className="bl-check" disabled={!date || busy === "load"}>{busy === "load" ? "Looking…" : "Show papers"}</button>
      </form>
      {error ? <p className="bl-error" role="alert">{error}</p> : null}
      {list ? (
        list.length ? (
          <>
            <p className="bl-note bl-left">Papers from {longDay(date)}. Choose one: it’s yours to keep in My library.</p>
            <ul className="bl-eds">
              {list.map((ed) => (
                <li key={ed.id}>
                  <span className="bl-ed-cover">{ed.image ? <img src={ed.image} alt="" loading="lazy" /> : null}</span>
                  <strong>{ed.paper}</strong>
                  {ed.owned ? <button type="button" className="bl-ghost" onClick={() => history.push(`/view_single_paper/${ed.id}`)}>In your library · Read</button>
                    : <button type="button" className="bl-pay bl-pay-sm" disabled={Boolean(busy)} onClick={() => claim(ed)}>{busy === ed.id ? "Opening…" : "Read free"}</button>}
                </li>
              ))}
            </ul>
          </>
        ) : <p className="ac-muted">We don’t have any papers from {longDay(date)}. Try a day close to it.</p>
      ) : null}
    </section>
  );
}
